import { Provider } from '@angular/core';
import { SignalrProvider } from './abstract';
import { SignalrProviderImpl } from './impl';

export const signalProvider: Provider = {
	provide: SignalrProvider,
	useClass: SignalrProviderImpl,
};
